// NOTE: keep DISCLAIMER_V1 and DISCLAIMER_CURRENT_VERSION in sync with
// tach-architecture/common/types-and-constants/src/constants/accounting.ts
// — every change must update both repos and bump the version string.
export const DISCLAIMER_V1 = `Informational reporting only. TACH provides bookkeeping tools to help you organize your business activity. The reports here are based on your TACH account activity and your category assignments; they may not include income, expenses, or adjustments that live outside of TACH. They are not a substitute for professional tax or accounting advice. Please review with a qualified professional before relying on them for any filing or business decision.`;

export const DISCLAIMER_CURRENT_VERSION = 'v1.0';

// UI-only, and deliberately NOT versioned or mirrored in tach-architecture: the
// backend never generates a demo report. DISCLAIMER_V1 asserts the figures above
// it come from the customer's own TACH activity, which is false under demo data —
// and this block is the only provenance marker that survives a print or a
// screenshot, since the "Preview Data" ribbon is hover-only.
export const DISCLAIMER_PREVIEW = `Preview data — not your account activity. The figures on this screen are a sample, shown so you can see how TACH bookkeeping reports work before your account is active. They are not drawn from your business and do not reflect any real income, expenses, or transactions. Your own reports become available once onboarding is complete. Nothing here is tax or accounting advice.`;

export const EXPENSE_CATEGORIES = [
  'fuel',
  'preventative_maintenance',
  'tires',
  'repairs',
  'tolls',
  'insurance',
  'licensing',
  'truck_payments',
] as const;

export const REPORT_PACK_STATUS = {
  Generating: 'generating',
  Ready: 'ready',
  Failed: 'failed',
} as const;

export type ReportPackStatus =
  (typeof REPORT_PACK_STATUS)[keyof typeof REPORT_PACK_STATUS];
